<template>
    <v-main class="ml-6 mt-3" v-if="!loading">
        <v-row justify="center">
            <v-card class="mt-4" width="800" v-if="!changePassword&&!twoFactor&&!forceMFA">
                <v-card-text class="pa-0 pb-4">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title>My Account</v-toolbar-title>
                    </v-toolbar>
                    <v-row class="pl-4 mt-4">
                        <v-col cols="12"><h3>Your personal information</h3></v-col>
                    </v-row>
                    <v-row class="pl-4 mt-4">
                        <v-col cols="4">
                            User
                        </v-col>
                        <v-col cols="8">
                            {{ gebr.gebr_code }}
                        </v-col>
                    </v-row>
                    <v-row class="pl-4 mt-0">
                        <v-col cols="24">
                            Name
                        </v-col>
                        <v-col cols="8">
                            {{ gebr.gebr_naam }}
                        </v-col>
                    </v-row>
                    <v-row class="pl-4 mt-0">
                        <v-col cols="4">
                            e-mail
                        </v-col>
                        <v-col cols="8">
                            {{ gebr.gebr_email }}
                        </v-col>
                    </v-row>
                    <v-row class="pl-4 mt-0">
                        <v-col cols="4">Language</v-col>
                        <v-col cols="8">{{ gebr.taal_code }}</v-col>
                    </v-row>
                    <v-row class="pl-4 mt-0">
                        <v-col cols="4">Country</v-col>
                        <v-col cols="8">{{ gebr.land_code }}</v-col>
                    </v-row>
                    <v-row class="pl-4 mt-0">
                        <v-col cols="4">Multi Factor Authentication</v-col>
                        <v-col cols="8">
                            <span v-if="gebr.gebr_mfa">
                                <v-icon class="mb-1 mr-2" color="green">mdi-check</v-icon>
                                <span class="mfa">Active</span>
                                <span>
                                    <br>Login with authenticator App will be required every 30 days
                                    <br>and from every new location or device / browser.
                                </span>
                            </span>
                            <span v-else>
                                <v-icon class="mb-1 mr-2" color="red">mdi-close</v-icon>
                                <span class="nomfa">Not yet activated</span>
                                <span>
                                    <br>Login with authenticator App will be required every 30 days
                                    <br>and from every new location or device / browser.
                                </span>
                            </span>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider class="pt-0 ma-0"></v-divider>
                <v-card-actions class="pt-0 ma-0">
                    <div class="flex-grow-1"></div>
                    <v-btn class="mt-4" color="success" @click="changeMyPassword" v-if="!changePassword">Change my password</v-btn>
                    <v-btn class="mt-4" color="success" @click="twoFactorSetup" v-if="!twoFactor">Add/Replace Two Factor</v-btn>
                </v-card-actions>
            </v-card>
            <v-card class="mt-4" width="800" v-if="changePassword">
                <v-form class="px-0" ref="form" v-model="valid" @submit.prevent="updMyPassword">
                    <v-card-text class="pa-0 pb-4">
                        <v-toolbar color="primary" dark>
                            <v-toolbar-title>Change user password</v-toolbar-title>
                        </v-toolbar>
                    </v-card-text>
                    <v-card-text class="pa-4">
                        <v-text-field class="pl-8"
                            name="username"
                            autocomplete="username"
                            v-model="gebr.gebr_code"
                            disabled>
                        </v-text-field>
                        <v-text-field
                            label="New Password"
                            autocomplete="current-password"
                            v-model="newPassword"
                            :append-icon="showNew ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="showNew ? 'text' : 'password'"
                            prepend-icon="mdi-key-variant"
                            :rules="[passwordRules]"
                            @click:append="showNew = !showNew"
                            required>
                        </v-text-field>
                        <div class="bar-container pl-20" v-if="newPassword!==''">
                            <!-- Render 5 bars using v-for -->
                            <div class="mx-2"></div>
                            <div v-for="index in 5" :key="index">
                                <div v-if="score >= index" :class="vibe"></div>
                                <div v-else class="small-bar grey"></div>
                            </div>
                        </div>
                        <v-text-field
                            label="Re-enter new Password"
                            v-model="reenteredPassword"
                            :append-icon="showNew2 ? 'mdi-eye' : 'mdi-eye-off'"
                            prepend-icon="mdi-key-variant"
                            :type="showNew2 ? 'text' : 'password'"
                            :rules="[passwordRules, passwordConfirmationRule]"
                            @click:append="showNew2 = !showNew2"
                            required>
                        </v-text-field>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-text>
                        <div class="ml-10">
                            <b>The new pasword must</b><br/>
                            <div class="ml-4">
                                * Have at least one capital letter<br/>
                                * Have at least one lowercase letter<br/>
                                * Have at least one number<br/>
                                * Can't contain a white Space<br/>
                                * Can't contain your own name<br/>
                                * Must be longer than 10 characters<br/>
                            </div>
                        </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <div class="flex-grow-1"></div>
                        <v-btn color="success" @click="cancelMyPassword">Cancel change password</v-btn>
                        <v-btn type="submit" color="success" :disabled="!valid">Change my password</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
            <v-card class="mt-4" width="1200" v-if="twoFactor||forceMFA">
                <v-card-text class="pa-0">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title>ARES 2 Factor Authentication Setup</v-toolbar-title>
                    </v-toolbar>
                    <div class="pa-4 pb-0" v-if="forceMFA">Before you can continue with ares you must set up 2 Factor Athentication</div>
                    <v-row class="pa-4">
                        <v-col cols="12">
                            <p class="font-weight-black app">
                                Authenticator App<br>
                                <span class="steps">Folow the five steps</span>
                            </p>
                            <v-divider></v-divider>
                        </v-col>
                        <v-col cols="8">
                            <v-row dense>
                                <v-col cols="4" class="ml-4">
                                    <img src="@/assets/ms-authenticator.png" width="96">
                                </v-col>
                                <v-col cols="7"  class="ml-4">
                                    <v-icon class="mb-1 mr-1">mdi-numeric-1-circle-outline</v-icon>
                                    Install the "Microsoft Authenticator App" (<img src="@/assets/ms-authenticator.png" width="24">) On Your Phone<br>
                                    You can do this from the offical store (App Store, Google Play, ...)
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="4" class="ml-4">
                                    <img src="@/assets/ms-add-account1.png" width="250">
                                </v-col>
                                <v-col cols="7" class="ml-4">
                                    <v-icon class="mb-1 mr-1">mdi-numeric-2-circle-outline</v-icon>
                                    Open the Microsoft Authenticator App<br>
                                    And click (+) to add an account.
                                </v-col>
                                <v-col cols="4" class="ml-4">
                                    <img src="@/assets/ms-add-account2.png" width="250">
                                </v-col>
                                <v-col cols="7" class="ml-4">
                                    <v-icon class="mb-1 mr-1">mdi-numeric-3-circle-outline</v-icon>
                                    For type type of account you can choose Other (Overig).<br>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="4">
                            <v-icon class="mb-1 mr-1">mdi-numeric-4-circle-outline</v-icon>
                            Scan the QR-code from this page<br>
                            This will add/replace the "Villa for You ARES" account on the App.<br>
                            <v-row justify="center" class="mb-4"><img class="mt-8" :src="imageUrl + '?' + mfaSecret" v-if="imageUrl !== ''"/></v-row>

                            <v-icon class="mb-1 mr-1">mdi-numeric-5-circle-outline</v-icon>
                            Compete the process by entering a generated response in the field and then clicking on "Activate 2FA"
                            <div class="ma-4" v-if="imageUrl !== ''">
                                <v-row>
                                    <v-text-field label="Enter a 6 digit response code" v-model="mfaResponse"></v-text-field>
                                </v-row>
                                <v-row>
                                    <v-btn  color="success" @click="twoFactorCode">Activate 2FA</v-btn>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider v-if="!forceMFA"></v-divider>
                <v-card-actions v-if="!forceMFA">
                    <div class="flex-grow-1"></div>
                    <v-btn color="success" @click="cancelFactorSetup">Back</v-btn>
                </v-card-actions>
            </v-card>
        </v-row>
        <navBar title="Ares - Users" :home="true" type="gebr" v-if="!forceMFA"/>
    </v-main>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import { zxcvbn, zxcvbnOptions } from '@zxcvbn-ts/core'
import * as common from '@zxcvbn-ts/language-common'

export default {
    components: {
        navBar,
    },
    props: {
      forceMFA: {
          type: Boolean,
          required: false,
          default: false,
      },
      forceMFAuser: {
          type: String,
          required: false,
          default: "",
      },
    },
    data() {
        return {
            // Page
            loading: true,

            // User info
            gebr: {
                gebr_encrid: "",
                gebr_code: "",
                gebr_naam: "",
                gebr_email: "",
                taal_code: "",
                land_code: "",
                gebr_mfa: false,
                gebr_mfaSecret: "",
                gebr_mfaQR: "",
            },

            // Change password
            changePassword: false,
            oldPassword: "",
            newPassword: "",
            reenteredPassword: "",
            showOld: false,
            showNew: false,
            showNew2: false,
            snackbar: false,
            valid: false,
            passwordRules: value => {
                const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{10,}$/
                return (
                    pattern.test(value) ||
                    "Min. 10 characters with at least one capital letter, one non-capitol letter and one number"
                );
            },
            // error_message: "",

            // Two Factor
            twoFactor: false,
            imageUrl: "",
            mfaSecret: "",
            mfaResponse: "",
            mfaValid: false,

            // Strength
            regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{10,}$/
            // score: 3,
        }
    },
    computed: {
        passwordConfirmationRule() {
            return ((this.newPassword === this.reenteredPassword) && (this.score >= 5)) || "Password must match";
        },
        score () {
            if (this.newPassword === '') return 0

            let sc = zxcvbn(this.newPassword)
            let newScore = sc.score

            if (newScore === 0) return 1

            // Onze eigen wens: minimaal 10, Hoofdletter, kleine letter, cijfer
            if (!this.regex.test(this.newPassword)) return newScore

            // " " niet in wachtwoord
            if (this.newPassword.includes(' ')) return newScore

            let names = this.gebr.gebr_naam.split(" ")

            // voornaam niet in wachtwoord
            if (this.newPassword.toLowerCase().includes(names[0].toLowerCase())) return newScore

            // achternaam
            if (this.newPassword.toLowerCase().includes(names[names.length - 1].toLowerCase())) return newScore

            return newScore + 1
        },
        vibe() {
            switch (this.score) {
                // case 0: return "small-bar error"
                case 1: return "small-bar error"
                case 2: return "small-bar orange"
                case 3: return "small-bar amber"
                case 4: return "small-bar yellow"
                case 5: return "small-bar success"
            }
            return "small-bar grey"
        }
    },
    mounted() {
        this.twoFactor = false;
        this.imageUrl = "";
        this.mfaSecret = "";
        this.mfaResponse = "";
        this.mfaValid = false;
        zxcvbnOptions.setOptions({
            dictionary: common.dictionary,
            graphs: common.adjacencyGraphs
        })
        this.getMyAccount()
    },
    methods: {
        updateData(data) {
            this[data.field] = data.value;
        },
        getMyAccount() {
            this.$axios.post("ares/json/ares/syst/gebr/getMyAccount.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getMyAccount",
                },
                getMyAccount: {
                    forceMFAuser: this.forceMFAuser,
                },
            }).then((res) => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    this.gebr = res.data.getMyAccount;
                    this.oldPassword = "";
                    this.newPassword = "";
                    this.reenteredPassword = "";
                    this.changePassword = false;
                    this.twoFactor = false;
                    this.imageUrl = res.data.getMyAccount.gebr_mfaQR;
                    this.mfaSecret = res.data.getMyAccount.gebr_mfaSecret;
                    this.mfaValid = false;
                    // this.forceMFA = res.data.getMyAccount.forceMFA;
                    console.log('Force MFA: ', this.forceMFA)
                    this.loading = false;
                }
            });
        },
        updMyPassword() {
            console.log("old/new", this.oldPassword, " " ,this.newPassword);
            this.$axios.post("ares/json/ares/syst/gebr/updMyPassword.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "updMyPassword",
                },
                updMyPassword: {
                    oldPassword: this.oldPassword,
                    newPassword: this.newPassword,
                },
            }).then((res) => {
                if (res.data.error) {
                    console.log(res.data.error);
                    this.$store.dispatch('setSnackbar', {
                        showing: true,
                        text: res.data.error.message,
                        color: "error"
                    });
                } else {
                    console.log(res.data);
                    this.$store.dispatch('setSnackbar', {
                        showing: true,
                        text: "Password has been updated",
                        color: "success"
                    });
                    this.changePassword = false;
                }
            });
        },
        cancelMyPassword() {
            this.changePassword = false;
        },
        changeMyPassword() {
            this.oldPassword = "";
            this.newPassword = "";
            this.reenteredPassword = "";

            this.showOld = false;
            this.showNew = false;
            this.showNew2 = false;

            this.changePassword = true;
        },
        twoFactorSetup() {
            this.twoFactor = true;
        },
        cancelFactorSetup() {
            this.twoFactor = false;
        },
        twoFactorQR() {
            this.imageUrl ="";
            this.secret = "";
            // Generate new QR
            this.$axios.post("ares/json/ares/syst/gebr/getMyQR.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "getMyQR",
                },
                getMyQR: {
                },
            }).then((res) => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    //console.log(res.data.getMyQR);
                    this.imageUrl = res.data.getMyQR.image;
                    this.mfaSecret = res.data.getMyQR.secret;
                    this.mfaValid = false;
                }
            });

        },
        twoFactorCode() {
            // Generate new QR
            this.$axios.post("ares/json/ares/syst/gebr/checkMyQR.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "checkMyQR",
                },
                checkMyQR: {
                    mfaSecret: this.mfaSecret,
                    mfaResponse: this.mfaResponse,
                    forceMFAuser: this.forceMFAuser,
                },
            }).then((res) => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    console.log(res.data.checkMyQR);
                    if (res.data.checkMyQR) {
                        if (this.forceMFA) {
                            localStorage.setItem('login', this.loginId);
                            this.$session.set("ARES", res.data.token);
                            this.$router.push(res.data.dashboard);
                        } else {
                            this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: "Two Factor Authentication Activated",
                            color: "success"
                        });
                        this.mfaValid = true;
                        this.twoFactor = false;
                        this.getMyAccount();
                        }

                    } else {
                        this.$store.dispatch('setSnackbar', {
                            showing: true,
                            text: "Two Factor code incorrect",
                            color: "error"
                        });
                    }
                }
            });
        },
    },
}
</script>

<style scoped>
    .app {
        font-size: 20px;
    }
    .v-icon {
        color: red;
    }
    .mfa {
        font-size: 16px;
        color:green;
    }
    .nomfa {
        font-size: 16px;
        color:red;
    }
    .steps {
        font-size: 16px;
        color:red;
    }

    .bar-container {
        display: flex;
        gap: 8px; /* Space between bars */
        align-items: center;
        padding: 10px;
    }

    .small-bar {
        width: 140px; /* Adjust width as needed */
        height: 6px; /* Adjust height for "small" bar */
        /* background-color: #3498db; *//* Bar color */
        border-radius: 5px; /* Makes the corners rounded */
    }
</style>
